import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

interface IProp {
  shareBtnHandler: () => void;
  isHasMyList: boolean;
}


const ShareComponent: React.FC<IProp> = ({ shareBtnHandler, isHasMyList }) => {
  const { t } = useTranslation();
  const [utagData] = useRecoilState(utagObjectAtom)
  return (
    <div className="share-container">
      <button
        className={`dk-btn__secondary ${isHasMyList ? "disabled" : ""}`}
        id="btn-share"
        onClick={() => {
          callGTMAnalytics(utagData, "Share Results");
          return shareBtnHandler();
        }}
        track-data="ref_page_event=Share Results"
      >
        {t('xref-share-results')}{' '}
        <svg
          xmlns="https://www.w3.org/2000/svg"
          width="20"
          height="16"
          fill="currentColor"
          className="bi bi-share"
          viewBox="0 0 16 16"
          style={{ marginTop: -5, marginBottom: -3 }}
        >
          <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        </svg>
      </button>
    </div>
  )
}

export default ShareComponent;